import { MoneyBagIcon } from "../icons"

const STEPS = [
  {
    title: "Nominate a child",
    description: "Nominate a child you know needs Redempta, and we'll take it from there.",
    image: "/images/home/step-nominate.png",
    alt: "A child holding books",
  },
  {
    title: "Sponsor",
    description: "Cover tuition, books, uniform and materials — end to end, no leakage.",
    image: "/images/home/step-sponsor.png",
    alt: "A child writing at a desk",
  },
  {
    title: "Get real updates",
    description: "Termly reports, photos and progress from your child's teacher.",
    image: "/images/home/step-updates.png",
    alt: "A child reading a book with lightbulbs above their head",
  },
]

const CARD_ROTATIONS = ["-rotate-2", "rotate-1", "rotate-[-2deg]"] as const

export function SponsorshipSteps() {
  return (
    <section className="bg-cream-50 py-10 sm:py-24">
      <div className="public-container">
        <div className="flex justify-center">
          <span className="inline-flex items-center gap-2.5 rounded-full border border-ink/10 bg-cream-100 px-4 py-1.5 text-sm font-medium text-ink">
            <MoneyBagIcon />
            Sponsorship
          </span>
        </div>

        <div className="mx-auto mt-8 max-w-2xl text-center">
          <h2 className="font-display text-[36px] font-bold leading-tight text-ink sm:text-[48px] sm:leading-none">
            Three steps. <span className="text-forest-700">One life</span> changed.
          </h2>
          <p className="mt-4 text-base text-ink sm:text-lg">
            Sponsorship is direct. You fund a specific child&rsquo;s year, and we send you real updates from their classroom.
          </p>
        </div>

        <div className="mx-auto mt-10 grid max-w-[1260px] gap-8 md:grid-cols-3 md:gap-8 lg:mt-16">
          {STEPS.map((step, index) => (
            <article key={step.title} className={`relative mx-auto min-h-[310px] w-full max-w-[390px] bg-white px-5 pb-6 pt-6 shadow-sm lg:min-h-[460px] lg:px-6 lg:pb-8 lg:pt-7 ${CARD_ROTATIONS[index]}`}>
              <div className="relative mt-1 h-[145px] overflow-hidden bg-forest-700 p-3 lg:h-[250px]">
                <img src={step.image} alt={step.alt} className="h-full w-full object-contain" loading="lazy" />
              </div>
              <img
                src="/images/home/badge.png"
                alt=""
                aria-hidden
                className="absolute -top-8 left-1/2 h-16 w-16 -translate-x-1/2 object-contain"
              />
              <h3 className="mt-5 text-xl font-medium text-ink lg:mt-7 lg:text-2xl">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink lg:text-base">{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
